import { connector } from './constant';

export const defaultComparator = (valueA, valueB) => {
  // const isNumericA = /^\d+$/.test(valueA);
  // const isNumericB = /^\d+$/.test(valueB);
  // // for sorting. to avoid case like '34' > '2000'
  // if (isNumericA && isNumericB) {
  //   const numA = +valueA;
  //   const numB = +valueB;
  //   return numA === numB ? 0 : numA < numB ? -1 : 1;
  // }
  if (typeof valueA === 'string' && typeof valueB === 'string') {
    const newValueA = valueA.split(connector)?.[0];
    const newValueB = valueB.split(connector)?.[0];

    return newValueA.localeCompare(newValueB, undefined, { caseFirst: 'lower' });
  }

  if (valueA === valueB) {
    return 0;
  }
  if ((valueA === undefined || valueA === null) && !!valueB) {
    return -1;
  } else if ((valueB === undefined || valueB === null) && !!valueA) {
    return 1;
  }
  return valueA < valueB ? -1 : 1;
};
